import React from 'react';
import { Box,  SimpleGrid} from "@chakra-ui/react"
import { Center, Square, Circle } from "@chakra-ui/react"
import YouTube from '@u-wave/react-youtube';

  
  
const Recursos = () => {
    return <SimpleGrid Columns={2} spacing={6}> 
		 		<Center>
					<Box>		
						<YouTube
			  				video="GUJX1jK5R1Y"
			  				autoplay
					         width={640}
			          		height={480}
							showRelatedVideos={true}
						/>
					</Box>
 				</Center>
 	
					<Box>		
						<YouTube
			  				video="Ay4O0vDZDAI"
					         width={640}
			          		height={480}
						/>
					</Box>
 							
					<Box>		
						<YouTube
			  				video="qX3xougDDNE"
					         width={640}
			          		height={480}
						/>
					</Box>
 							
					<Box>		
						<YouTube
			  				video="mher_UnKDFQ"
					         width={640}
			          		height={480}
						/>	
					</Box>
	 
			</SimpleGrid>
}

export default Recursos
